// import function to register Swiper custom elements
import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";

new Swiper(".swiper-awards", {
  modules: [Autoplay, Pagination],
  loop: true,
  speed: 1200,
  watchSlidesProgress: true,
  spaceBetween: 30,
  breakpoints: {
    360: {
      slidesPerView: 1,
    },
    860: {
      slidesPerView: 3,
    },
  },
  pagination: {
    el: ".swiper-pagination-awards",
    clickable: true,
  },
  autoplay: {
    delay: 5000,
  },
  speed: 600,
});
